import { StyleSheet, View, ScrollView, ActivityIndicator } from "react-native";
import React, { useEffect, useState } from "react";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import Button from "@components/Button";
import t from "@constants/localization";
import { shareOnWhatsapp } from "@utils/shareEntity";
import analytics from "@services/analytics";
import { REFER_EARN } from "@constants/analyticsEventsCT";
import Text from "@components/CustomText";
import { useSelector } from "react-redux";
import Image from "@components/common/Image";
import { getCMSEntityById } from "@services/cmsV2-api";
import { normalize, width } from "@constants/metrics";
import colors from "@constants/color";

const PATH = "screens/ReferStepScreen";

const ReferEarnStepsScreen = ({ navigation, route }) => {
  const { language } = useSelector((state) => state.auth.user);
  const [isLoading, setLoading] = useState(true);
  const [cmsItems, setCmsItems] = useState();

  const {
    cmsPoweredEntities: {
      REFER_STEPS_HI,
      REFER_STEPS_EN,
      REFERRAL_CITIES_BG_PAGE,
    },
  } = useSelector(({ configReducer }) => configReducer.appSettings) || {};

  const {
    params: { wa },
  } = route;

  useEffect(() => {
    if (REFER_STEPS_HI && REFER_STEPS_EN && REFERRAL_CITIES_BG_PAGE) {
      Promise.all([
        getCMSEntityById({
          id: REFER_STEPS_HI,
          root: true,
          limit: 10,
        }),
        getCMSEntityById({
          id: REFER_STEPS_EN,
          root: true,
          limit: 10,
        }),
        getCMSEntityById({
          id: REFERRAL_CITIES_BG_PAGE,
          root: true,
          limit: 10,
        }),
      ])
        .then((response) => {
          const [
            {
              data: { image_link: referStepsCitiesHiImage },
            },
            {
              data: { image_link: referStepsCitiesEnImage },
            },
            {
              data: { image_link: referStepsImage },
            },
          ] = response;
          setCmsItems({
            referStepsCitiesImage:
              language === "en"
                ? referStepsCitiesEnImage
                : referStepsCitiesHiImage,
            referStepsImage,
          });
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [REFER_STEPS_HI, REFER_STEPS_EN, REFERRAL_CITIES_BG_PAGE, language]);

  const handleOnPressReferKare = () => {
    analytics.trackEvent(REFER_EARN.REFER_REFER_NOW, {
      screen: "Refer Details page",
      medium: "Whatsapp",
    });
    shareOnWhatsapp({
      message: wa.waMsg,
      image: wa.waImage,
    });
  };

  if (isLoading) {
    return (
      <View style={styles.loaderContainer}>
        <ActivityIndicator color={colors.primary} size="large" />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <HeaderWithBackAndTitle
        navigation={navigation}
        route={{ name: "" }}
        headertitle={t(`${PATH}/earnMethod`)}
        hideShadow={true}
      />
      <ScrollView>
        <View style={styles.stepsContainer}>
          {cmsItems?.referStepsCitiesImage && (
            <Image
              resizeMode="contain"
              style={styles.stepsImage}
              source={{ uri: cmsItems.referStepsCitiesImage }}
            />
          )}
        </View>
        <View style={styles.cityContainer}>
          <Text variant="title_18" style={styles.cityTitleText}>
            {t(`${PATH}/referInAvailableCities`)}
          </Text>
          {cmsItems?.referStepsImage && (
            <Image
              resizeMode="contain"
              style={styles.availableCitiesImage}
              source={{ uri: cmsItems.referStepsImage }}
            />
          )}
        </View>
        <View style={styles.ctaContainer}>
          <Button
            buttonWidth="100%"
            btnText={t("screens/ReferEarn/referNow")}
            buttonFontType="head1"
            height={56}
            borderRadius={10}
            onPress={handleOnPressReferKare}
          />
        </View>
      </ScrollView>
    </View>
  );
};

export default ReferEarnStepsScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loaderContainer: {
    flex: 1,
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  stepsContainer: {
    backgroundColor: "#fff",
    padding: 15,
  },
  cityContainer: {
    // padding: 15,
  },
  cityTitleText: {
    fontSize: 18,
    color: "rgba(0, 0, 0, 0.86)",
    fontWeight: "700",
    marginLeft: 15,
    marginTop: 15,
  },
  ctaContainer: {
    width: "100%",
    padding: 15,
    marginVertical: 15,
    paddingTop: 0,
    backgroundColor: "#e5e5e5",
  },
  availableCitiesImage: {
    width,
    height: normalize(435),
    marginTop: 15,
    borderRadius: 15,
    backgroundColor: "white",
  },
  stepsImage: {
    height: 370,
  },
});
